import React from 'react';
import { OAuthAuthenticationService } from '@ipc/ipc-core';

import HeaderMenu from '../../custom/HeaderMenu';

const AppHeaderCenterContainer = () => (
  <div className="header-center-container">
    {
      OAuthAuthenticationService.loggedIn() && <HeaderMenu />
    }
  </div>
);

export default AppHeaderCenterContainer;
